import { ModalComponent } from '../baseComponents';
import { QRCode } from 'antd'; // Switched to use QRCode from "antd"

export const ShowQRCode = ({ isOpen, onCancel, qrCodeValue }) => {
  const initialValues = {};

  const sections = [
    {
      heading: (
        <div className="flex flex-col items-center justify-center h-full">
          <h3 className="text-lg font-semibold mb-4">
            Scan the QR code below to open appointment
          </h3>
          <QRCode
            value={qrCodeValue}
            style={{ width: '256px', height: 'auto' }}
          />
        </div>
      ),
      className: 'grid grid-cols-1 gap-4',
      fields: [], // No fields are necessary since we're only displaying a QR code
    },
  ];

  return (
    <ModalComponent
      open={isOpen}
      className={'qr-code-modal flex items-center justify-center'}
      formClassName={'grid grid-cols-1 gap-4'}
      initialValues={initialValues}
      sections={sections}
      submitButtonText="Close"
      modalStyle={{
        width: 'auto',
        height: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      cancelButtonText={null}
      handleSubmit={() => {
        onCancel(); // Assuming closing the modal is the only action needed
      }}
      handleCancel={() => {
        onCancel(); // Assuming closing the modal is the only action needed
      }}
    />
  );
};
